import { Center, Tab, TabList, TabPanel, TabPanels, Tabs, useToast } from "@chakra-ui/react";
import React, { useState } from "react";
import { AggregatedScopeThreeQuestions, GeneralAndScopeOneAndTwoQuestions, SuppliersDataListed } from "./components";
import { useTranslation } from "react-i18next";
import { useExportSuppliersAggregatedData } from "../../../../../hooks/query/reports";
import { showErrorToast } from "../../../../../utils";
import { useDispatch } from "react-redux";
import { hideAppSpinner, showAppSpinner } from "../../../../../context/Store/slices/appSpinnerSlice";
import { SupplierEngagement } from "./components/SupplierEngagement";
import DataQuality from "./components/DataQuality";

function SuppliersDataReport({ year, quarter }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.suppliersData.tabs",
  });
  const toast = useToast();
  const dispatch = useDispatch();
  const [suppliersTabIndex, setSuppliersTabIndex] = useState(0);

  const { mutate: exportSuppliersAggregatedData } = useExportSuppliersAggregatedData({
    onError: (err) => {
      const parsedErrorObj = JSON.parse(String.fromCharCode.apply(null, new Int8Array(err.response.data)));
      showErrorToast(toast, parsedErrorObj?.message ?? err.message);
      dispatch(hideAppSpinner());
    },
    onSettled: () => dispatch(hideAppSpinner()),
    cacheTime: 0,
  });

  const handleExportClick = () => {
    dispatch(showAppSpinner());
    exportSuppliersAggregatedData({ params: { year, quarter } });
  };

  return (
    <Tabs colorScheme="customScheme" index={suppliersTabIndex} onChange={setSuppliersTabIndex} overflow="auto" isLazy>
      <Center>
        <TabList borderBottom="none" overflow="auto">
          <Tab mb={0} _focus={{ boxShadow: "none" }}>
            {t("supplierEngagement")}
          </Tab>
          <Tab mb={0} _focus={{ boxShadow: "none" }}>
            {t("listed")}
          </Tab>
          <Tab mb={0} _focus={{ boxShadow: "none" }}>
            {t("generalAndScope1And2Aggregated")}
          </Tab>
          <Tab mb={0} _focus={{ boxShadow: "none" }}>
            {t("scope3Aggregated")}
          </Tab>
          <Tab mb={0} _focus={{ boxShadow: "none" }}>
            {t("dataQuality")}
          </Tab>
        </TabList>
      </Center>
      <TabPanels>
        <TabPanel padding="0">
          <SupplierEngagement />
        </TabPanel>
        <TabPanel padding="0">
          <SuppliersDataListed selectedYear={year} selectedQuarter={quarter} />
        </TabPanel>
        <TabPanel padding="0">
          <GeneralAndScopeOneAndTwoQuestions
            selectedYear={year}
            selectedQuarter={quarter}
            handleExportClick={handleExportClick}
          />
        </TabPanel>
        <TabPanel padding="0">
          <AggregatedScopeThreeQuestions
            selectedYear={year}
            selectedQuarter={quarter}
            handleExportClick={handleExportClick}
          />
        </TabPanel>
        <TabPanel>
          <DataQuality />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
}

export default SuppliersDataReport;
